import { ReportNavigationProvider } from '@/pages/Reports/ReportNavigationProvider'
import type { ReactNode } from 'react'
import Navbar from '@/components/Navbar'
import { PageNavigationProvider } from '@/app/navigation/PageNavigationProvider'
import { useAuth } from '@/app/auth/AuthContext'

export function AuthenticatedLayout({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  return <PageNavigationProvider key={user?.id}><ReportNavigationProvider><div className="chef-authenticated">
    <div className="chef-authenticated__content">{children}</div>
    <Navbar />
  </div></ReportNavigationProvider></PageNavigationProvider>
}
